const startOfDay = date => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

const endOfDay = date => {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
};

const daysAgo = (now, days) => {
  const d = new Date(now);
  d.setDate(d.getDate() - days);
  return d;
};

// Parse a native <input type="date"> value ("YYYY-MM-DD") as a LOCAL date.
// new Date('YYYY-MM-DD') would parse as UTC midnight and shift the day in
// non-UTC timezones.
const parseDateInput = value => {
  if (!value) return null;
  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
};

export const buildDateRangeParams = (preset, { from, to } = {}, now = new Date()) => {
  switch (preset) {
    case 'today':
      return {
        created_after: startOfDay(now).toISOString(),
        created_before: endOfDay(now).toISOString(),
      };
    case 'last_7_days':
      return {
        created_after: startOfDay(daysAgo(now, 6)).toISOString(),
        created_before: endOfDay(now).toISOString(),
      };
    case 'last_30_days':
      return {
        created_after: startOfDay(daysAgo(now, 29)).toISOString(),
        created_before: endOfDay(now).toISOString(),
      };
    case 'this_month':
      return {
        created_after: startOfDay(
          new Date(now.getFullYear(), now.getMonth(), 1)
        ).toISOString(),
        created_before: endOfDay(now).toISOString(),
      };
    case 'custom': {
      const params = {};
      const fromDate = parseDateInput(from);
      const toDate = parseDateInput(to);
      if (fromDate) params.created_after = startOfDay(fromDate).toISOString();
      if (toDate) params.created_before = endOfDay(toDate).toISOString();
      return params;
    }
    default:
      return {};
  }
};

export const formatCustomRangeLabel = (from, to) => {
  const format = date =>
    date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
  const fromDate = parseDateInput(from);
  const toDate = parseDateInput(to);
  if (fromDate && toDate) return `${format(fromDate)} – ${format(toDate)}`;
  if (fromDate) return `≥ ${format(fromDate)}`;
  if (toDate) return `≤ ${format(toDate)}`;
  return null;
};
